const langArr = {
  "header-title" : {
    "en" : "futuristic wireless speaker",
    "ua" : "футуристична бездротова колонка"
  },
  "header-text" : {
    "en" : "Luna’s performance is balanced and smooth in all frequency ranges which makes the music both naturally pleasant and distinctly more layered.",
    "ua" : "Гра Luna збалансована та плавна у всіх частотних діапазонах, що робить музику природно приємною та помітно більш багатошаровою."
  },
  "specs" : {
    "en" : "specs",
    "ua" : "характеристика"
  },
  "buy" : {
    "en" : "buy",
    "ua" : "купити"
  },
  "nav-our-story" : {
    "en" : "our story",
    "ua" : "наша історія"
  },
  "nav-about-us" : {
    "en" : "about us",
    "ua" : "про нас"
  },
  "nav-features" : {
    "en" : "features",
    "ua" : "особливості"
  },
  "nav-get-touch" : {
    "en" : "get in touch",
    "ua" : "зв'язатись з нами"
  },
  "futuristic-design-title" : {
    "en" : "futuristic design",
    "ua" : "футуристичний дизайн"
  },
  "futuristic-design-text" : {
    "en" : "To give Luna a truly flawless look, we specifically picked aircraft grade aluminum as its material and adopted both three-dimensional stretch-bending technology and a high precision cold forging technique.",
    "ua" : "Щоб надати Luna справді бездоганного вигляду, ми спеціально вибрали авіаційний алюміній як його матеріал і застосували технологію тривимірного згинання на розтяг і технологію високоточного холодного кування."
  },
  "speaker-system-title" : {
    "en" : "tweeter speaker system",
    "ua" : "твітерна акустична система"
  },
  "speaker-system-text" : {
    "en" : "To deliver a more layered sound performance better than a sole full-range speaker, our team equipped Luna with one more tweeter speaker responsible for high-frequency sound independently.",
    "ua" : "Щоб забезпечити більш багатошаровий звук, кращий, ніж єдиний повнодіапазонний динамік, наша команда оснастила Luna ще одним твітерним динаміком, який відповідає за високочастотний звук незалежно."
  },
  "multiroom-system-title" : {
    "en" : "multiroom system",
    "ua" : "багатокімнатна система"
  },
  "multiroom-system-text" : {
    "en" : "Luna is natively compatible with your home Wi-Fi. Set up multiple speakers in different rooms to expand your music experience into the entire house.",
    "ua" : "Luna нативно сумісна з домашнім Wi-Fi. Встановіть кілька динаміків у різних кімнатах, щоб розширити музичний досвід у всьому будинку."
  },
  "lighting-system-title" : {
    "en" : "intuitive lighting system",
    "ua" : "інтуїтивна система освітлення"
  },
  "lighting-system-text" : {
    "en" : "An intuitive user interface allows you to adjust the hue and saturation of color for lighting that fits any mood and situation.",
    "ua" : "Інтуїтивно зрозумілий інтерфейс користувача дозволяє регулювати відтінок і насиченість кольорів для освітлення, яке відповідає будь-якому настрою та ситуації."
  },
  "designed-future-title" : {
    "en" : "Designed for the future",
    "ua" : "Створено для майбутнього"
  },
  "designed-future-text" : {
    "en" : "In 2014, a group of geeky industrial designers, engineering veterans and acoustic experts formed crazybaby. This is a bunch of passionate people who are crazy enough to think they can challenge the industry with disruptive audio products. ",
    "ua" : "У 2014 році група промислових дизайнерів, ветеранів техніки та експертів з акустики створила crazybaby. Це група пристрасних людей, які настільки божевільні, щоб думати, що можуть кинути виклик індустрії за допомогою руйнівних аудіопродуктів."
  },
  "luna-eye-title" : {
    "en" : "Luna eye",
    "ua" : "Місячне око"
  },
  "luna-eye-text" : {
    "en" : "Luna Eye is to the essence of this innovative light and audio system. It comprises an independent tweeter speaker, a light guiding component, a dome and a ring ornament.",
    "ua" : "Luna Eye — суть цієї інноваційної системи освітлення та аудіосистеми. Він складається з незалежного високочастотного динаміка, світловодного компонента, купола та кільцевого орнаменту."
  },
  "see-more" : {
    "en" : "See more about us",
    "ua" : "Дізнайтеся більше про нас"
  },
  "quote" : {
    "en" : "It really took me by surprise honestly to have such full beautiful sound that coming out of this small compact device. And with the brush aluminum surface, it feels so familiar. Like my iPhone.",
    "ua" : "Мене, чесно кажучи, справді здивувало таке чудове звучання, яке виходить із цього маленького компактного пристрою. А завдяки щітковій алюмінієвій поверхні це виглядає так знайомо. Як мій iPhone."
  },
  "person-name" : {
    "en" : "Garrett Martin",
    "ua" : "Гаррет Мартін"
  },
  "person-profession" : {
    "en" : "Creative Director",
    "ua" : "Креативний директор"
  },
  "features" : {
    "en" : "Features",
    "ua" : "Особливості"
  },
  "connectivity" : {
    "en" : "Connectivity",
    "ua" : "Підключення"
  },
  "hands-free" : {
    "en" : "Hands Free Wireless Audio",
    "ua" : "Бездротова аудіосистема Hands Free"
  },
  "multiroom" : {
    "en" : "Smart Multiroom System Set Up",
    "ua" : "Налаштування системи Smart Multiroom"
  },
  "party-mode" : {
    "en" : "Party Mode with 6.0 Units and above",
    "ua" : "Режим вечірки з одиницями 6.0 і вище"
  },
  "multi-speaker" : {
    "en" : "MESHNET Multi Speaker Network",
    "ua" : "Мережа з декількома колонками MESHNET"
  },
  "app-features" : {
    "en" : "App Features",
    "ua" : "Функції програми"
  },
  "customize-music" : {
    "en" : "Customize Music Schedule",
    "ua" : "Налаштуйте музичний розклад"
  },
  "wake-up" : {
    "en" : "Wake Up with Favorite Songs",
    "ua" : "Прокидайся з улюбленими піснями"
  },
  "home-detection" : {
    "en" : "Home Detection Auto Wake Up",
    "ua" : "Автоматичне розпізнавання будинку"
  },
  "color-wheel" : {
    "en" : "Color Wheel",
    "ua" : "Кольорога палітра"
  },
  "sounds-music" : {
    "en" : "Sound & Music",
    "ua" : "Звук & Музика"
  },
  "fell-in-chest" : {
    "en" : "Feel-in-chest Base Power",
    "ua" : "Базова потужність відчуття в грудях"
  },
  "lossless-transmission" : {
    "en" : "Lossless Digital Audio Transmission",
    "ua" : "Передача цифрового звуку без втрат"
  },
  "stereo-pairing" : {
    "en" : "Easy & Stable Stereo Pairing",
    "ua" : "Просте та стабільне стереоз’єднання"
  },
  "high-frequency-sound" : {
    "en" : "Crisp and Clear High Frequency Sound",
    "ua" : "Чіткий і чистий високочастотний звук"
  },
  "cloud-music" : {
    "en" : "Streams from Cloud Music and Local Library",
    "ua" : "Потоки з Cloud Music і локальної бібліотеки"
  },
  "auto-music" : {
    "en" : "Auto Music from Last Song Stopped",
    "ua" : "Автоматична зупинка музики з останньої пісні"
  },
  "have-questions" : {
    "en" : "Do you have any questions?",
    "ua" : "Маєш питання?"
  },
  "btn-send" : {
    "en" : "Send",
    "ua" : "Надіслати"
  },
  "rights-reserved" : {
    "en" : "© 2019 All rights reserved. Terms of Use & Privacy Policy",
    "ua" : "© 2019 Усі права захищено. Умови використання та політика конфіденційності"
  }
}

export default langArr;

